import { render, staticRenderFns } from "./stardisplay.vue?vue&type=template&id=8e87cc0c&"
import script from "./stardisplay.vue?vue&type=script&lang=js&"
export * from "./stardisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e87cc0c')) {
      api.createRecord('8e87cc0c', component.options)
    } else {
      api.reload('8e87cc0c', component.options)
    }
    module.hot.accept("./stardisplay.vue?vue&type=template&id=8e87cc0c&", function () {
      api.rerender('8e87cc0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2XxwAyTtv83ZE/JS/comp/stardisplay.vue"
export default component.exports